/* tslint:disable */
/* eslint-disable */
/**
 * GLC.Portal.Api (local) Portal BFF
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const IAPPRODUCT = {
    LivingAnnuity: 'LAX',
    RetirementAnnuity: 'RAF',
    PensionFund: 'PENSCH',
    ProvidentFund: 'PRDSCH',
    PreservationPensionFund: 'PPE',
    PreservationProvidentFund: 'PPR',
    DiscretionarySavings: 'DSP',
    TaxFreeSavings: 'TFS'
} as const;
export type IAPPRODUCT = typeof IAPPRODUCT[keyof typeof IAPPRODUCT];


export function IAPPRODUCTFromJSON(json: any): IAPPRODUCT {
    return IAPPRODUCTFromJSONTyped(json, false);
}

export function IAPPRODUCTFromJSONTyped(json: any, ignoreDiscriminator: boolean): IAPPRODUCT {
    return json as IAPPRODUCT;
}

export function IAPPRODUCTToJSON(value?: IAPPRODUCT | null): any {
    return value as any;
}

